export default "__VITE_ASSET__CRgDtRGM__"